import { Link } from 'react-router-dom';

import { Text } from '../../../components';
import { COLORS } from '../../../styles/colors';

function NavigationText({ data }: { data: string }) {
  return (
    <Text
      commonStyles={{
        fontSize: '1rem',
        color: COLORS.blue3,
        display: 'block',
        marginBottom: '0.9375rem',
      }}
    >
      <Link to="/"> F-copy </Link>
      <div
        style={{
          display: 'inline-block',
          color: COLORS.black,
        }}
      >
        {data}
      </div>
    </Text>
  );
}

export default NavigationText;
